import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

export function useUserListByIds(ids: string[]) {
  const { api } = useTacticHooks();
  return useQuery({
    queryKey: ['organizations.usersWithOptions', { ids }],

    queryFn: async () => {
      const res = await api.client.organizations.usersById(ids);
      return res;
    }
  });
}
